import * as React from 'react';
import { Path } from 'react-native-svg';
import { Icon, IIconProps } from 'native-base';

const SvgTimeSensitive = (props: IIconProps) => {
  return (
    <Icon viewBox="0 0 20 20" {...props}>
      <Path d="M14.492 6.21V3.595h1.68c.086 0 .156-.07.156-.156V2.343a.157.157 0 00-.156-.156H3.828a.157.157 0 00-.156.156v1.094c0 .085.07.156.156.156h1.68V6.21c0 1.592.828 2.992 2.078 3.789a4.487 4.487 0 00-2.078 3.79v2.616h-1.68a.157.157 0 00-.156.157v1.093c0 .086.07.157.156.157h12.344c.086 0 .156-.07.156-.157v-1.093a.157.157 0 00-.156-.157h-1.68V13.79A4.487 4.487 0 0012.414 10a4.487 4.487 0 002.078-3.79zm-1.406 7.58v2.616H6.914V13.79c0-.824.32-1.6.904-2.182A3.06 3.06 0 0110 10.703c.824 0 1.6.32 2.182.904a3.06 3.06 0 01.904 2.182zm0-7.58c0 .825-.32 1.6-.904 2.183A3.06 3.06 0 0110 9.297c-.824 0-1.6-.32-2.182-.904a3.059 3.059 0 01-.904-2.182V3.594h6.172V6.21z" />
    </Icon>
  );
};

export default SvgTimeSensitive;
